/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminOrganization,
  AdminV1NetworksAdminsByOrganizationListParams,
  AdminV1NetworksAdminsListParams,
  AdminV1OrganizationsListParams,
  AdminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListParams,
  AdminV1OrganizationsNetworksOrganizationsListParams,
  ChangeParentResponse,
  CopyTFAContentsRequest,
  CopyTrainingCollectionsStatusResponse,
  NetworkAdminCreate,
  NetworkAdminCreateResponse,
  NetworkOrganizationCreate,
  NetworkOrganizationResponse,
  NetworkOrganizationWithCounts,
  PaginatedAdminOrganizationList,
  PaginatedNetworkAdminListList,
  PaginatedNetworkOrganizationWithCountsList,
  PaginatedParentOrganizationList,
  PatchedAdminOrganization,
  PatchedChangeParentNetwork,
  PatchedToggleAdmin
} from '.././model';

import adminV1NetworksAdminsListMutator from '../../shared/services/axios-client';
import adminV1NetworksAdminsToggleAdminPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1NetworksAdminsByOrganizationListMutator from '../../shared/services/axios-client';
import adminV1NetworksAdminsCreateNetworkAdminCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsArchiveDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsNetworksOrganizationsCreateOrganizationCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCopyTfaContentCreateMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * List all network administrators in the user's hierarchy.
 * @summary List all network administrators in the user's hierarchy.
 */
export const adminV1NetworksAdminsList = (
    params?: AdminV1NetworksAdminsListParams,
 options?: SecondParameter<typeof adminV1NetworksAdminsListMutator<PaginatedNetworkAdminListList>>,) => {
      return adminV1NetworksAdminsListMutator<PaginatedNetworkAdminListList>(
      {url: `/api/admin/v1/networks/admins/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Toggle admin status for a profile.
 * @summary Toggle admin status for a profile.
 */
export const adminV1NetworksAdminsToggleAdminPartialUpdate = (
    id: number,
    patchedToggleAdmin: PatchedToggleAdmin,
 options?: SecondParameter<typeof adminV1NetworksAdminsToggleAdminPartialUpdateMutator<NetworkAdminCreateResponse>>,) => {
      return adminV1NetworksAdminsToggleAdminPartialUpdateMutator<NetworkAdminCreateResponse>(
      {url: `/api/admin/v1/networks/admins/${id}/toggle_admin/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedToggleAdmin
    },
      options);
    }
  /**
 * Get network administrators grouped by organization.
 * @summary Get network administrators grouped by organization.
 */
export const adminV1NetworksAdminsByOrganizationList = (
    params?: AdminV1NetworksAdminsByOrganizationListParams,
 options?: SecondParameter<typeof adminV1NetworksAdminsByOrganizationListMutator<PaginatedNetworkAdminListList>>,) => {
      return adminV1NetworksAdminsByOrganizationListMutator<PaginatedNetworkAdminListList>(
      {url: `/api/admin/v1/networks/admins/by_organization/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new network administrator.
 * @summary Create a new network administrator.
 */
export const adminV1NetworksAdminsCreateNetworkAdminCreate = (
    networkAdminCreate: NetworkAdminCreate,
 options?: SecondParameter<typeof adminV1NetworksAdminsCreateNetworkAdminCreateMutator<NetworkAdminCreateResponse>>,) => {
      return adminV1NetworksAdminsCreateNetworkAdminCreateMutator<NetworkAdminCreateResponse>(
      {url: `/api/admin/v1/networks/admins/create_network_admin/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: networkAdminCreate
    },
      options);
    }
  export const adminV1OrganizationsList = (
    params?: AdminV1OrganizationsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsListMutator<PaginatedAdminOrganizationList>>,) => {
      return adminV1OrganizationsListMutator<PaginatedAdminOrganizationList>(
      {url: `/api/admin/v1/organizations/`, method: 'GET',
        params
    },
      options);
    }
  export const adminV1OrganizationsCreate = (
    adminOrganization: NonReadonly<AdminOrganization>,
 options?: SecondParameter<typeof adminV1OrganizationsCreateMutator<AdminOrganization>>,) => {
      return adminV1OrganizationsCreateMutator<AdminOrganization>(
      {url: `/api/admin/v1/organizations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminOrganization
    },
      options);
    }
  /**
 * Get all organizations under the URL organization with optional
filtering.
 * @summary Get all organizations under the URL organization with optional
filtering.
 */
export const adminV1OrganizationsNetworksOrganizationsList = (
    organizationId: number,
    params?: AdminV1OrganizationsNetworksOrganizationsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsListMutator<PaginatedNetworkOrganizationWithCountsList>>,) => {
      return adminV1OrganizationsNetworksOrganizationsListMutator<PaginatedNetworkOrganizationWithCountsList>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Get a specific organization with hierarchy counts.
 * @summary Get a specific organization with hierarchy counts.
 */
export const adminV1OrganizationsNetworksOrganizationsRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsRetrieveMutator<NetworkOrganizationWithCounts>>,) => {
      return adminV1OrganizationsNetworksOrganizationsRetrieveMutator<NetworkOrganizationWithCounts>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Archive an organization by setting is_active=False
 * @summary Archive an organization by setting is_active=False
 */
export const adminV1OrganizationsNetworksOrganizationsArchiveDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsArchiveDestroyMutator<void>>,) => {
      return adminV1OrganizationsNetworksOrganizationsArchiveDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/${id}/archive/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Get available networks for changing parent organization, excluding descendants to prevent circular dependencies
 * @summary Get available networks for changing parent organization, excluding descendants to prevent circular dependencies
 */
export const adminV1OrganizationsNetworksOrganizationsAvailableParentNetworksList = (
    organizationId: number,
    params?: AdminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListParams,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListMutator<PaginatedParentOrganizationList>>,) => {
      return adminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListMutator<PaginatedParentOrganizationList>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/available_parent_networks/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Change an organization's parent network.
 * @summary Change an organization's parent network.
 */
export const adminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdate = (
    organizationId: number,
    patchedChangeParentNetwork: PatchedChangeParentNetwork,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdateMutator<ChangeParentResponse>>,) => {
      return adminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdateMutator<ChangeParentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/change_parent_network/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedChangeParentNetwork
    },
      options);
    }
  /**
 * Create a new network or club organization.
 * @summary Create a new network or club organization.
 */
export const adminV1OrganizationsNetworksOrganizationsCreateOrganizationCreate = (
    organizationId: number,
    networkOrganizationCreate: NetworkOrganizationCreate,
 options?: SecondParameter<typeof adminV1OrganizationsNetworksOrganizationsCreateOrganizationCreateMutator<NetworkOrganizationResponse>>,) => {
      return adminV1OrganizationsNetworksOrganizationsCreateOrganizationCreateMutator<NetworkOrganizationResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/networks/organizations/create_organization/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: networkOrganizationCreate
    },
      options);
    }
  export const adminV1OrganizationsRetrieve = (
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsRetrieveMutator<AdminOrganization>>,) => {
      return adminV1OrganizationsRetrieveMutator<AdminOrganization>(
      {url: `/api/admin/v1/organizations/${id}/`, method: 'GET'
    },
      options);
    }
  export const adminV1OrganizationsUpdate = (
    id: number,
    adminOrganization: NonReadonly<AdminOrganization>,
 options?: SecondParameter<typeof adminV1OrganizationsUpdateMutator<AdminOrganization>>,) => {
      return adminV1OrganizationsUpdateMutator<AdminOrganization>(
      {url: `/api/admin/v1/organizations/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminOrganization
    },
      options);
    }
  export const adminV1OrganizationsPartialUpdate = (
    id: number,
    patchedAdminOrganization: NonReadonly<PatchedAdminOrganization>,
 options?: SecondParameter<typeof adminV1OrganizationsPartialUpdateMutator<AdminOrganization>>,) => {
      return adminV1OrganizationsPartialUpdateMutator<AdminOrganization>(
      {url: `/api/admin/v1/organizations/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminOrganization
    },
      options);
    }
  export const adminV1OrganizationsDestroy = (
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsDestroyMutator<void>>,) => {
      return adminV1OrganizationsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${id}/`, method: 'DELETE'
    },
      options);
    }
  export const adminV1OrganizationsCopyTfaContentCreate = (
    id: number,
    copyTFAContentsRequest: CopyTFAContentsRequest,
 options?: SecondParameter<typeof adminV1OrganizationsCopyTfaContentCreateMutator<CopyTrainingCollectionsStatusResponse>>,) => {
      return adminV1OrganizationsCopyTfaContentCreateMutator<CopyTrainingCollectionsStatusResponse>(
      {url: `/api/admin/v1/organizations/${id}/copy_tfa_content/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyTFAContentsRequest
    },
      options);
    }
  export type AdminV1NetworksAdminsListResult = NonNullable<Awaited<ReturnType<typeof adminV1NetworksAdminsList>>>
export type AdminV1NetworksAdminsToggleAdminPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1NetworksAdminsToggleAdminPartialUpdate>>>
export type AdminV1NetworksAdminsByOrganizationListResult = NonNullable<Awaited<ReturnType<typeof adminV1NetworksAdminsByOrganizationList>>>
export type AdminV1NetworksAdminsCreateNetworkAdminCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1NetworksAdminsCreateNetworkAdminCreate>>>
export type AdminV1OrganizationsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsList>>>
export type AdminV1OrganizationsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCreate>>>
export type AdminV1OrganizationsNetworksOrganizationsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsList>>>
export type AdminV1OrganizationsNetworksOrganizationsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsRetrieve>>>
export type AdminV1OrganizationsNetworksOrganizationsArchiveDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsArchiveDestroy>>>
export type AdminV1OrganizationsNetworksOrganizationsAvailableParentNetworksListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsAvailableParentNetworksList>>>
export type AdminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsChangeParentNetworkPartialUpdate>>>
export type AdminV1OrganizationsNetworksOrganizationsCreateOrganizationCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsNetworksOrganizationsCreateOrganizationCreate>>>
export type AdminV1OrganizationsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsRetrieve>>>
export type AdminV1OrganizationsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsUpdate>>>
export type AdminV1OrganizationsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPartialUpdate>>>
export type AdminV1OrganizationsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsDestroy>>>
export type AdminV1OrganizationsCopyTfaContentCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCopyTfaContentCreate>>>
